import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumTpProductListSortOption implements BaseEnumType {
  private static allValues: EnumTpProductListSortOption[] = []; // make sure this is top-most
  
  public static abvLowToHigh = new EnumTpProductListSortOption(0, "AbvLowToHigh", "enum_tp_product_list_sort_option_abv_low_to_high");
  public static abvHighToLow = new EnumTpProductListSortOption(1, "AbvHighToLow", "enum_tp_product_list_sort_option_abv_high_to_low");
  public static priceLowToHigh = new EnumTpProductListSortOption(2, "PriceLowToHigh", "enum_tp_product_list_sort_option_price_low_to_high");
  public static priceHighToLow = new EnumTpProductListSortOption(3, "PriceHighToLow", "enum_tp_product_list_sort_option_price_high_to_low");
  public static productNameAlphabetical = new EnumTpProductListSortOption(4, "ProductNameAlphabetical", "enum_tp_product_list_sort_option_product_name_alphabetical");
  public static productBrandAlphabetical = new EnumTpProductListSortOption(5, "ProductBrandAlphabetical", "enum_tp_product_list_sort_option_product_brand_alphabetical");
  public static packageTypeAlphabetical = new EnumTpProductListSortOption(6, "PackageTypeAlphabetical", "enum_tp_product_list_sort_option_package_type_alphabetical");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumTpProductListSortOption.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isAbvLowToHigh() { return this === EnumTpProductListSortOption.abvLowToHigh; }
  public isAbvHighToLow() { return this === EnumTpProductListSortOption.abvHighToLow; }
  public isPriceLowToHigh() { return this === EnumTpProductListSortOption.priceLowToHigh; }
  public isPriceHighToLow() { return this === EnumTpProductListSortOption.priceHighToLow; }
  public isProductNameAlphabetical() { return this === EnumTpProductListSortOption.productNameAlphabetical; }
  public isProductBrandAlphabetical() { return this === EnumTpProductListSortOption.productBrandAlphabetical; }
  public isPackageTypeAlphabetical() { return this === EnumTpProductListSortOption.packageTypeAlphabetical; }

  public static getValues(): readonly EnumTpProductListSortOption[] {
    return EnumTpProductListSortOption.allValues;
  }

  public static getValuesExcept0(): readonly EnumTpProductListSortOption[] {
    return EnumTpProductListSortOption.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumTpProductListSortOption {
    const found = EnumTpProductListSortOption.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumTpProductListSortOption - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumTpProductListSortOption): EnumTpProductListSortOption {
    const found = name ? EnumTpProductListSortOption.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumTpProductListSortOption - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumTpProductListSortOption>): boolean {
    return this.key === other?.key;
  }
}